module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'tc2p1trx',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
